<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Account Group</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="account-sidebar h-full">
                    <div class="mb-4 text-center">
                        <span class="fa-layers fa-4x mb-3">
                            <i class="fa fa-circle"></i>
                            <i class="fas fa-users fa-inverse" data-fa-transform="shrink-6.5"></i>
                        </span>

                        <p class="text-lg font-light"></p>
                    </div>

                    <div class="mb-3">
                        <label>ID</label>
                        <p>&infin;</p>
                    </div>
                </div>

                <div class="account-body">
                    <form class="profile-form">
                        <div class="form-field">
                            <input type="text" v-model="group.name">
                            <label>Name</label>
                        </div>

                        <div class="form-field">
                            <textarea rows="3" v-model="group.description"></textarea>
                            <label>Description</label>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'AccountGroupsView',
    props: {
        //
    },
    components: {
        //
    },
    data() {
        return {
            group: {
                name: null,
                description: null,
            },
        }
    },
    computed: {
        //
    },
    mounted() {
        this.setMetaTitle('Create Account Group | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    methods: {
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.post(route('accountGroups.create'), this.group)
                .then(response => {
                    this.group = response.data.accountGroup
                    this.$bus.$emit('alert.success', 'Account Group has been saved')
                    this.$router.push({name: 'accountgroups.list', params: {newRecord: this.group}})
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    },
    watch: {
        //
    },
}
</script>

<style lang="less">
.account-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.hidden-input {
    input {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .hide {
        display: none;
    }

    .edit-field-link {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #222222;
        word-wrap: break-word;
    }
}

.profile-form {
    .section-title {
        margin-top: 20px;
    }

    .form-title {
        margin-bottom: 20px;
    }
}
</style>
